import { mix } from 'polished';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Playlists } from '../../../@resources/sounds/music';
import { LFC } from '../../../Legacy';
import { Colors } from '../../../ui';
import { PressableProps, RenderBounds, RenderBox, RenderInner, usePose, usePressable2 } from '../../canvas/visualization/RenderHelpers';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Jukebox, JukeboxProgressAttr } from './Jukebox';

const PlayIcon = () =>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"    >
        <path fillRule="evenodd" clipRule="evenodd" d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM12 9L24 16L12 23V9Z" fill="currentColor" />
    </svg>;

const PauseIcon = () =>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM10 9H14V23H10V9ZM22 9H18V23H22V9Z" fill="currentColor" />
    </svg>;


const PrevIcon = () =>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 20V0L4.44444 7.77778V0H0V20H4.44444V12.2222L20 20Z" fill="currentColor" />
    </svg>;

const NextIcon = () =>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V20L15.5556 12.2222V20H20V0H15.5556V7.77778L0 0Z" fill="currentColor" />
    </svg>;

const ShuffleIcon = () =>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
        <path fill="currentColor" d="M 46.15625 12.009766 C 45.563797 11.985297 45 12.448641 45 13.119141 L 45 17 L 42.175781 17 C 39.829781 17 37.653562 18.164187 36.351562 20.117188 L 31.75 27.019531 L 27.148438 20.117188 C 25.846438 18.165188 23.670219 17 21.324219 17 L 14 17 C 12.896 17 12 17.896 12 19 C 12 20.104 12.896 21 14 21 L 21.324219 21 C 22.329219 21 23.263313 21.499938 23.820312 22.335938 L 29.345703 30.625 L 23.320312 39.664062 C 22.762312 40.500062 21.829219 41 20.824219 41 L 14 41 C 12.896 41 12 41.896 12 43 C 12 44.104 12.896 45 14 45 L 20.824219 45 C 23.170219 45 25.347438 43.834812 26.648438 41.882812 L 31.75 34.230469 L 36.851562 41.882812 C 38.153563 43.834813 40.329781 45 42.675781 45 L 45 45 L 45 48.880859 C 45 49.774859 46.003281 50.301969 46.738281 49.792969 L 55.240234 43.910156 C 55.877234 43.470156 55.877234 42.528891 55.240234 42.087891 L 46.738281 36.207031 C 46.003281 35.699031 45 36.225141 45 37.119141 L 45 41 L 42.675781 41 C 41.670781 41 40.736688 40.500062 40.179688 39.664062 L 34.154297 30.625 L 39.679688 22.335938 C 40.237687 21.499938 41.170781 21 42.175781 21 L 45 21 L 45 24.880859 C 45 25.774859 46.003281 26.301969 46.738281 25.792969 L 55.240234 19.910156 C 55.877234 19.470156 55.877234 18.528891 55.240234 18.087891 L 46.738281 12.207031 C 46.554531 12.080031 46.353734 12.017922 46.15625 12.009766 z"></path>
    </svg>;

const LoopIcon = () =>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
        <path fill="currentColor" d="M50 32c1.104 0 2 .896 2 2v6c0 3.86-3.141 7-7 7H23v3.88c0 .894-1.004 1.42-1.739.912l-8.501-5.881c-.637-.441-.637-1.383 0-1.823l8.501-5.88C21.996 37.699 23 38.225 23 39.119V43h22c1.654 0 3-1.346 3-3v-6C48 32.896 48.896 32 50 32zM51.24 18.088c.637.441.637 1.383 0 1.823l-8.501 5.881C42.004 26.301 41 25.775 41 24.88V21H19c-1.654 0-3 1.346-3 3v6c0 1.104-.896 2-2 2s-2-.896-2-2v-6c0-3.86 3.141-7 7-7h22v-3.881c0-.894 1.004-1.42 1.739-.912L51.24 18.088z"></path>
    </svg>;


// const Button = styled.div<{ state: string, play?: boolean, toggle?: boolean }>`
//     position: absolute;
//     inset: 0;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     color: #FFFFFF;
//     border-radius: 2px;
//     background: ${p => shadeColor('#222222', p.state)};
//     /* color: ${p => p.toggle ? p.active ? Colors.sky300 : Colors.primaryLight : p.active ? '#FFFFFF' : '#DDDDDD'}; */
//     color: white;
// `;

type RenderButtonProps = PressableProps & { color: string, icon: any, primary?: boolean, active?: boolean };
const RenderButton = React.memo<RenderButtonProps>(({ area, state, color, icon, primary, active }) => {
    const Icon = icon;
    const props = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '2px',
        background: active ? mix(.8, color, Colors.contrastColorFor(color)) : '',
        color: primary || state !== 'idle' ? '#fff' : 'rgba(255,255,255,0.9)',
        transform: primary && state !== 'idle' ? 'scale(1.1)' : 'scale(1)',
    };

    return <RenderBox {...area.toCSS()} {...props}>
        <Icon />
    </RenderBox>;
});

const ProgressBar = styled.div<{ opacity?: number, width?: number }>`
    position: absolute;
    width: ${props => props.width || 160}px;
    height: 0;
    border-top: 2px solid #222222;
    border-radius: 2px;
    opacity: ${props => props.opacity || 0.5};
`;

const TimeText = styled.div`
    font-size: 9px;
    padding-top: 2px;
    font-variant-numeric: tabular-nums;
`;

const marquee = keyframes`
    0% {
        transform: translateX(0%);
    }
    50% {
        transform: translateX(-105%);        
    }
    50.01% {
        transform: translateX(105%);
    }   
    100% {
        transform: translateX(0%);
    }
`;

const PlaylistText = styled.div`
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const TitleMarquee = styled.div`
    position: absolute;
    left: 0;
    top: 0;    
    width: 100%;
    animation: ${marquee} 15s linear infinite;
    animation-delay: 2s;
`;

const TrackText = styled.div`
    position: relative;
    height: 30px;
    font-size: 22px;
    white-space: nowrap;
    overflow: hidden;
`;

const GlareContainer = styled.div`
    position: absolute;
    bottom: -115px;
    right: -205px;
    z-index: 2;
`;

const RenderGlare = () => {
    return <GlareContainer>
        <svg width="110" height="78" viewBox="0 0 110 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 78C50.0006 63.7337 107.571 47.0574 110 0V78H0Z" fill="url(#paint0_linear_2813_19)" fillOpacity="0.25" />
            <defs>
                <linearGradient id="paint0_linear_2813_19" x1="55" y1="0" x2="55" y2="78" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D9D9D9" stopOpacity="0" />
                    <stop offset="1" stopColor="#D9D9D9" />
                </linearGradient>
            </defs>
        </svg>
    </GlareContainer>;
};

export const RenderTime = (seconds: number) => {
    const minutes = Math.max(0, Math.floor(seconds / 60));
    const secondsRemainder = Math.max(0, Math.floor(seconds % 60));
    return `${minutes.toString().padStart(2, '0')}:${secondsRemainder.toString().padStart(2, '0')}`;
};

const RenderScreen = ({ object, invoke, pressed }: { object: Jukebox, invoke: string, pressed: boolean }) => {
    const screen = object.layout.screen;
    const progress = JukeboxProgressAttr.get(object) % 1 ?? 0;
    const { currentTrack } = object.getCurrentTrack();
    const duration = currentTrack?.length / 1000 ?? 0;
    const currentTime = duration * progress;
    const active = invoke === 'screen';
    const playlist = Playlists.find(p => p.id === object.playlist);

    return <RenderBox>
        <RenderBox {...screen.toCSS()} background={active ? '#DDDDDD' : '#FFFFFF'} padding="15px" borderRadius="4px">
            <Flexer flex="column" justify="space-between" height="100%">
                <PlaylistText>Playlist: {playlist?.label}</PlaylistText>
                <TrackText>
                    <TitleMarquee key={currentTrack?.id}>{currentTrack?.label ?? 'None'}</TitleMarquee>
                </TrackText>
                <div>
                    <RenderBox>
                        <ProgressBar />
                        {progress > 0 && <ProgressBar opacity={1} width={progress * 160} />}
                    </RenderBox>
                    <Flexer flex="row" justify="space-between">
                        <TimeText>{RenderTime(currentTime)}</TimeText>
                        <TimeText>{RenderTime(duration)}</TimeText>
                    </Flexer>
                </div>
            </Flexer>
        </RenderBox>
        <RenderGlare />
    </RenderBox>;
};

export const JukeboxVisual: LFC<{ object: Jukebox }> = ({ object }) => {

    const pose = usePose(object);
    const invoke = pose.interaction?.type === 'invoke' ? pose.interaction.hint : null;
    const pressed = pose.pressed;

    const playPause = usePressable2(object, 'playPause');
    const next = usePressable2(object, 'next');
    const prev = usePressable2(object, 'prev');
    const shuffle = usePressable2(object, 'shuffle');
    const loop = usePressable2(object, 'loop');

    return <>
        <RenderBounds object={object}>
            <RenderInner object={object}>
                <RenderBox {...object.layout.base.toCSS()} background={object.color} borderRadius="12px">
                    <RenderScreen object={object} invoke={invoke} pressed={pressed} />
                    <RenderButton color={object.color} icon={ShuffleIcon} {...shuffle} active={object.shuffle} />
                    <RenderButton color={object.color} icon={PrevIcon} {...prev} />
                    <RenderButton color={object.color} icon={object.playing ? PauseIcon : PlayIcon} {...playPause} primary />
                    <RenderButton color={object.color} icon={NextIcon} {...next} />
                    <RenderButton color={object.color} icon={LoopIcon} {...loop} active={object.loop} />
                </RenderBox>
            </RenderInner>
        </RenderBounds>
    </>;
};
